import { CheckBoxRoundedIcon, IndeterminateCheckBoxRoundedIcon } from '@shared/components';

import { CheckboxType } from '../types';

export function getCheckboxIconByType(type: CheckboxType): JSX.Element | undefined {
  switch (type) {
    case CheckboxType.Checked:
      return <CheckBoxRoundedIcon />;
    case CheckboxType.Indeterminate:
      return <IndeterminateCheckBoxRoundedIcon />;
    case CheckboxType.Unchecked:
    default:
      return undefined;
  }
}
